import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { getDateTime, hideMiddleDigits } from "../../../../common/LocalFunction";
import { DIS_TYPE } from "../../../../LocalConstants";
import TableComponent from "../../../../common/Component/Table/TableComponent";

function LeadList () {
  const {t} = useTranslation ();
  const {values} = useFormikContext ();
  let columns = [
    {
      title:"Mã KHTN",
      field:"code",
    },
    {
      title:"Tên KHTN",
      field:"customerInfo",
      render:(rowData) => {
        return (
            <div style={{display:"flex", flexDirection:"column", gap:4}}>
              <strong>{rowData.fullName}</strong>
            </div>
        );
      },
    },
    {
      title:"SĐT",
      field:"phoneNumber",
      width:"300",
      render:(rowData) => {
        return (
            <div style={{display:"flex", flexDirection:"column", gap:4}}>
            <span>
                {hideMiddleDigits(rowData?.phoneNumber)}
            </span>
              {rowData?.phoneNumber2 &&
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber2)}
              </span>
              }
              {rowData?.phoneNumber3 &&
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber3)}
              </span>
              }
              {rowData?.phoneNumber4 &&
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber4)}
              </span>
              }
            </div>
        );
      },
    },
    {
      title:"Ngày tạo",
      field:"leadDate",
      render:(row) => getDateTime (row?.leadDate)
    },
    {
      title:"Dịch vụ quan tâm chính",
      field:"category.name",
    },
    {
      title:"Khu vực",
      field:"region.name",
    },
    {
      title:"Nguồn dữ liệu",
      field:"leadSource.name",
      render:(rowData) => {
        return (
            <div style={{display:"flex", flexDirection:"column", gap:4}}>
              <span>{rowData?.leadSource?.name}</span>
            </div>
        )
      }
    },
    {
      title:"Nguồn dữ liệu chi tiết",
      field:"leadSource.name",
      render:(rowData) => {
        return (
            <div style={{display:"flex", flexDirection:"column", gap:4}}>
              <span>{rowData?.leadSourceDetail?.name}</span>
            </div>
        )
      }
    },
    {
      title:"Loại KHTN",
      field:"leadType.name",
    },
    {
      title:"Phân loại KHTN",
      field:"leadCategory.name",
    },
    {
      title:"NV trực page",
      field:"pageAgent.name",
    },
    {
      title:"NV ads",
      field:"adsAgent.name",
    },
    {
      title:"NV Telesale",
      field:"agent.name",
    },
    {
      title:"Thời gian phân bổ",
      field:"assignmentTime",
      render:(row) => getDateTime (row?.assignmentTime)
    },
    {
      title:"Trạng thái tương tác cuối cùng",
      field:"lastReactionStatus.name",
      render:(rowData) => {
        // Tìm status trong leadStatusList theo code
        const matchedLastcall = rowData?.lastReactionStatus;

        return (
            <div
                style={{
                  fontWeight:rowData.parentId? "normal" : "bold",
                  backgroundColor:matchedLastcall?.backgroundColor? matchedLastcall.backgroundColor : "transparent",
                  padding:"2px 6px",
                  marginLeft:"2px",
                  borderRadius:"4px",
                  border:"1px solid #ccc",
                }}
            >
              {rowData.lastReactionStatus?.name}
            </div>
        );
      },
    },
    {
      title:"Trạng thái tương tác chi tiết cuối cùng",
      field:"lastReactionStatusDetail.name",
      hidden:true,
      render:(rowData) => {
        // Tìm status trong leadStatusList theo code
        const matchedLastcall = rowData?.lastReactionStatusDetail;

        return (
            <div
                style={{
                  fontWeight:rowData.parentId? "normal" : "bold",
                  backgroundColor:matchedLastcall?.backgroundColor? matchedLastcall.backgroundColor : "transparent",
                  padding:"2px 6px",
                  marginLeft:"2px",
                  borderRadius:"4px",
                  border:"1px solid #ccc",
                }}
            >
              {rowData.lastReactionStatusDetail?.name}
            </div>
        );
      },
    },
    {
      title:"Chiến dịch",
      field:"campaign.name",
      hidden:true
    },
    {
      title:"Cơ sở",
      field:"destination.name",
    },
    {
      title:"Địa chỉ",
      field:"address",
      hidden:true,
      render:(rowData) => {
        let address = "";
        if (rowData?.currentDetailResidence) {
          address = rowData?.currentDetailResidence;
        }

        if (rowData?.currentWard?.name) {
          address += (address? ", " : "") + rowData?.currentWard?.name;
        }

        if (rowData?.currentDistrict?.name) {
          address += (address? ", " : "") + rowData?.currentDistrict?.name;
        }

        if (rowData?.currentProvince?.name) {
          address += (address? ", " : "") + rowData?.currentProvince?.name;
        }
        return address || "";
      },
    },
    {
      title:"Ngày tạo của hệ thống",
      field:"createDate",
      render:(row) => getDateTime (row?.createDate),
      hidden:true
    },
    {
      title:"Người tạo của hệ thống",
      field:"createdBy",
      hidden:true
    },
    {
      title:"Kiểu phân bổ",
      field:"disType",
      hidden:true,
      render:(data) =>
          DIS_TYPE?.find ((item) => item.value === data?.disType)?.name || "-",
    },
    {
      title:"Mã khách hàng",
      field:"client.code",
      hidden:true,
    },
    {
      title:"Số trừ",
      field:"isBadLead",
      hidden:true,
      align:"center",
      render:(rowData) => (rowData?.isBadLead? "✓" : ""),
    },
  ];

  return (
      <section className="cards-container">
        <div className="cards-body">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableComponent
                  showOrdinalNumbers
                  data={values?.leads || []}
                  columns={columns}
                  noPagination={true}
              /> </Grid>
          </Grid>
        </div>
      </section>
  );
}

export default memo (observer (LeadList));
